import * as React from "react";
import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { Colors } from "../../utils/constants";
import Tooltip from "@mui/material/Tooltip";
import { useSelector } from "react-redux";

interface P {
  handleChange: (event: React.SyntheticEvent, newValue: number) => void;
  value: number;
  text: string[];
  disabledTabs?: string[];
}

export default function TabView(props: P) {
  const { handleChange, value, text, disabledTabs = [] } = props;
  const tabValue = sessionStorage.getItem("getTabSwitch");
  const selectedFilters: any = useSelector(
    (state: any) => state.browseFilterSlice
  );

  return (
    <Box ml="2.3%" sx={{ bgcolor: "background.paper" }}>
      <Tabs value={value} onChange={handleChange}>
        {text.map((label) => {
          const isDisabled = disabledTabs.includes(label);

          const tab = (
            <Tab
              key={label}
              label={label}
              disabled={isDisabled}
              sx={{
                fontSize: { xs: 14, sm: 16 },
                fontFamily: "Helvetica Neue",
                fontWeight: 700,
                color: Colors.gray_600,
              }}
            />
          );

          return isDisabled ? (
            <Tooltip
              key={label}
              title={
                label === "By Package" &&
                tabValue !== "3" &&
                selectedFilters.collectionsValueJournal !== "ONOS Collections"
                  ? "There is no package subscribed by Library"
                  : null
              }
              arrow
            >
              {/* Tooltip requires a single element (span) */}
              <span style={{ display: "inline-block", cursor: "pointer" }}>
                {tab}
              </span>
            </Tooltip>
          ) : (
            tab
          );
        })}
      </Tabs>
    </Box>
  );
}
